module.exports = __webpack_public_path__ + "static/all-in-one-kr-2ff41a319ddfe5940986b70f2be98026.png";